import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

const shopify = getServiceProvider('shopify');

export default createServiceProvider({
  ...shopify,
  requiresOAuthFlow: false,
  titleToId: true,
  titleToNamespace: true,
  hasConnectionStatus: true,
  singleton: true,
  defaultAuthenticationType: 'oauth2Bearer',
  avatarPath: avatars.shopify,
  logoPath: logos.shopify,
  getAdditionalLinks({ isAuthenticated, serviceId }) {
    if (isAuthenticated && serviceId) {
      return [{ title: 'Store', url: `https://${serviceId}.myshopify.com` }];
    }

    return [];
  }
});
